/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step2_Seaweed_ReadyInputs */



/**
* | output |
* | --- |
* | "oneCloud storage ready. No connection needed." |
*
* @param {Spaces_Wizard_Step2_Seaweed_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_seaweed_ready = /** @type {((inputs?: Spaces_Wizard_Step2_Seaweed_ReadyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Seaweed_ReadyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneCloud-Speicher bereit. Keine Verbindung erforderlich.")
	return /** @type {LocalizedString} */ ("oneCloud storage ready. No connection needed.")
});